import { push } from "react-router-redux";
import { composables } from "@orange-marmalade/paginate-this";
import { get } from "lodash";
import api from "APP_ROOT/api";
import { create as addItemToCart } from "APP_ROOT/Nav/SaleOrdersCart/actions";
import { SUCCESS } from "LIB/submission/constants";
import { refreshCarts } from "MODULES/session/actions";
import { toastr } from "react-redux-toastr";
import * as actionTypes from "./actionTypes";
import { reservedForSaleInventory } from "./pagination";

export const {
  pageActions: reservedForSaleInventoryActions,
  search: reservedForSaleSearch,
  setFilter: setReservedFilter
} = reservedForSaleInventory;

export function set(salesOrder) {
  return { type: actionTypes.SET, salesOrder };
}

export function setSalesOrderWithAllLineItems(salesOrderWithAllLineItems) {
  return {
    type: actionTypes.SET_SALES_ORDER_WITH_ALL_LINE_ITEMS,
    salesOrderWithAllLineItems
  };
}

export const expireLineItems = composables({
  listId: "salesOrders/lineItems"
}).expire;

export function fetch(id, presenter) {
  return dispatch =>
    api.salesOrders.show(id, presenter).then(({ data }) => {
      dispatch(set(data));
      dispatch(expireLineItems());
      return SUCCESS;
    });
}

export function fetchSalesOrderWithAllLineItems(id, cached) {
  return dispatch => {
    if (cached) {
      return api.salesOrders.cachedShow(id).then(({ data }) => {
        dispatch(setSalesOrderWithAllLineItems(data));
        return SUCCESS;
      });
    }
    return api.salesOrders.show(id).then(({ data }) => {
      dispatch(setSalesOrderWithAllLineItems(data));
      return SUCCESS;
    });
  };
}

export function bulkUpdateLineItems(data) {
  return (dispatch, getState) => {
    const salesOrderID = getState().salesOrderDetail.getIn([
      "salesOrder",
      "id"
    ]);

    return api.salesOrders.lineItems
      .bulkUpdate(salesOrderID, data)
      .then(({ data: salesOrder }) => {
        dispatch(set(salesOrder));
        dispatch(setSalesOrderWithAllLineItems(salesOrder));
        dispatch(expireLineItems());
        return SUCCESS;
      });
  };
}

export function update(data) {
  return (dispatch, getState) => {
    const id = getState().salesOrderDetail.getIn(["salesOrder", "id"]);

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return api.salesOrders.update(id, data).then(({ data: salesOrder }) => {
      dispatch(set(salesOrder));
      dispatch(expireLineItems());
      dispatch(fetchSalesOrderWithAllLineItems(id));
      return SUCCESS;
    });
  };
}

export function cancel(id, params, close) {
  return dispatch =>
    api.salesOrders.cancel(id, params).then(({ data }) => {
      dispatch(set(data));
      dispatch(expireLineItems());
      if (close) close();

      return SUCCESS;
    });
}

export function addItemToCartAndRefreshList(id) {
  return dispatch => {
    const addItem = () =>
      new Promise((resolve, __) => {
        resolve(dispatch(addItemToCart(id)));
      });

    addItem().then(() => {
      dispatch(reservedForSaleInventoryActions.expire());
    });
  };
}

export function convertSo(data) {
  return dispatch => {
    if (data.contact_id === "Add") {
      data.contact_id = null;
    }
    return api.salesOrders.convert(data).then(resp => {
      dispatch(push({ pathname: `/sales-orders/${resp.data.uuid}` }));
      dispatch(refreshCarts());
      return SUCCESS;
    });
  };
}

export function convertDummySo(data) {
  return dispatch => {
    if (data.contact_id === "Add") {
      data.contact_id = null;
    }
    return api.salesOrders.convertWithDummy(data).then(resp => {
      dispatch(push({ pathname: `/sales-orders/${resp.data.uuid}` }));
      return SUCCESS;
    });
  };
}

export function createCustomerRma(id, data) {
  return dispatch =>
    api.salesOrders.lineItems.customerRmas.create(id, data).then(resp => {
      dispatch(push({ pathname: `/rmas/${resp.data.id}` }));
      return SUCCESS;
    });
}

export function createOutrightSale(id, data) {
  return dispatch =>
    api.salesOrders.lineItems.outrightSale(id, data).then(resp => {
      dispatch(push({ pathname: `/sales-orders/${resp.data.sales_order_id}` }));
      return SUCCESS;
    });
}

export function updateLineItem(id, data) {
  return dispatch =>
    api.salesOrders.lineItems.update(id, data).then(resp => {
      dispatch(fetch(resp.data.sales_order_id));
      return SUCCESS;
    });
}

export function convertToExchange(id, data) {
  return dispatch =>
    api.salesOrders.lineItems.convertToExchange(id, data).then(resp => {
      dispatch(set(resp.data));
      dispatch(expireLineItems());
      return SUCCESS;
    });
}

export function createInternalOutrightSale(id, data) {
  return dispatch =>
    api.salesOrders.lineItems.internalOutrightSale(id, data).then(resp => {
      dispatch(push({ pathname: `/sales-orders/${resp.data.sales_order_id}` }));
      return SUCCESS;
    });
}

export function soCancellationReversal(id) {
  return dispatch =>
    api.salesOrders.cancellationReversal(id).then(({ data }) => {
      dispatch(set(data));
      dispatch(expireLineItems());
      return SUCCESS;
    });
}

export function validateContact({
  contact = {},
  company_id: companyId,
  contact_id: contactId = null
}) {
  const { email } = contact;

  if (email && contactId === "Add" && companyId) {
    return api.companies.contacts.search(companyId, { email }).then(resp => {
      if (resp.data.total_count > 0) {
        const errors = {
          contact: {
            email: ["Already Exists For Customer"]
          }
        };

        throw errors;
      }
    });
  }
  return Promise.resolve();
}

export function sync() {
  return (dispatch, getState) => {
    const id = getState().salesOrderDetail.getIn(["salesOrder", "id"]);
    return api.salesOrders
      .sync(id)
      .then(() => {
        toastr.success("SUCCESS", "Successfully Synced.");
        dispatch(fetchSalesOrderWithAllLineItems(id, false));
        return SUCCESS;
      })
      .catch(response => {
        toastr.error("ERROR", get(response, "errors", "Sync Failed"));
      });
  };
}

export function syncCoreRepairCharges() {
  return (dispatch, getState) => {
    const id = getState().salesOrderDetail.getIn(["salesOrder", "id"]);
    return api.salesOrders
      .syncCoreRepairCharges(id)
      .then(() => {
        toastr.success("SUCCESS", "Successfully Synced.");
        dispatch(fetchSalesOrderWithAllLineItems(id, false));
        return SUCCESS;
      })
      .catch(response => {
        toastr.error("ERROR", get(response, "errors", "Sync Failed"));
      });
  };
}

export function exchange(lineItem, params) {
  return dispatch => {
    const exchangePromise = api.salesOrders.lineItems.exchange(
      lineItem.id,
      params
    );

    exchangePromise.then(({ data }) => {
      // Extract salesOrderId based on the provided criteria
      let salesOrderId;
      if (data.third_exchange_item) {
        salesOrderId = data.third_exchange_item.id;
      } else if (data.second_exchange_item) {
        salesOrderId = data.second_exchange_item.id;
      }

      dispatch(push({ pathname: `/sales-orders/${salesOrderId}` }));

      return SUCCESS;
    });
  };
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/actions.js